export const getIsMarkedForDeletion = (objectId: string) => (state: EventDeletionStore) =>
  state.objectIds.includes(objectId);
